export default __webpack_public_path__ + "static/media/love.3e4ea8d4.gif";